(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["button"] && !Shopify.designMode) return;
  try {
    (function() {
    const params = window.location.search;
    if (!params) return;

    document.querySelectorAll('a[data-forward-params]').forEach(function(link) {
      const href = link.getAttribute('href');
      if (!href) return;

      const separator = href.includes('?') ? '&' : '?';
      link.setAttribute('href', href + separator + params.substring(1));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
